
import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';

export class TyreOfferSearchModel extends SearchBaseModel {
  public TyreOfferId: number;
  public RegistrationNumber: string;
  public CustomerId: number;
  public CustomerName: string;
  public ShipToGarageId: number;
  public IsRelocationOtherDestinationAddress: boolean;
  public IsTaken: boolean;
  public IsActive: boolean;
  public IsCompleted: boolean;
  public IsCanceled: boolean;
  public GarageId: number;
  public DateRange: DateRange;
  public Period: any;
  public TyreId: number;
  public Tyre: string;
  public City: string;
  public OrderId: number;

constructor() {
    super();
    this.TyreOfferId = null;
    this.RegistrationNumber = null;
    this.CustomerId = null;
    this.CustomerName = null;
    this.ShipToGarageId = null;
    this.IsRelocationOtherDestinationAddress = null;
    this.IsTaken = null;
    this.IsActive = null;
    this.IsCompleted = null;
    this.GarageId = null;
    this.DateRange = new DateRange();
    this.TyreId = null;
    this.Tyre = null;
    this.IsCanceled = null;
    this.City = null;
    this.Period = null;
    this.OrderId = null;
    }
}
